import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';

import * as component from '_core/utils/component';
import { InputProgress } from '_core/components/InputProgress';


export const RawTextInputBase = (props) => {
  const {
    classes,
    error,
    name,
    success,
    readOnly,
    onBlur,
    onChange,
    startAdornment,
    endAdornment,
    helperProps,
    labelProps,
    inputProps,
    htmlProps,
    checking,
    progressProps,
    renderProgress,
    ProgressComponent,
    ...rest
  } = props;

  const renderChecking = () => {
    if (!checking) {
      return null;
    }

    return renderProgress != null ? (
      renderProgress(progressProps)
    ) : (
      <ProgressComponent {...progressProps} />
    );
  };

  const HelperTextComponent = (childProps) => (
    <div>
      {renderChecking()}

      <FormHelperText {...childProps} />
    </div>
  );

  return (
    <TextField
      classes={{
        ...classes,
        root: component.className(classes?.root, success && 'success')
      }}
      name={name}
      variant="standard"
      FormHelperTextProps={{
        component: HelperTextComponent,

        ...helperProps
      }}
      InputLabelProps={{
        shrink: true,

        ...labelProps
      }}
      InputProps={{
        onBlur,
        onChange,
        readOnly,
        startAdornment,
        endAdornment,

        ...inputProps
      }}
      error={error}
      inputProps={htmlProps}
      {...rest}
    />
  );
};

RawTextInputBase.defaultProps = {
  name: '',
  autoComplete: 'on',
  ProgressComponent: InputProgress
};

RawTextInputBase.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  checking: PropTypes.bool,
  readOnly: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  startAdornment: PropTypes.node,
  endAdornment: PropTypes.node,
  helperProps: PropTypes.object,
  labelProps: PropTypes.object,
  inputProps: PropTypes.object,
  progressProps: PropTypes.object,
  renderProgress: PropTypes.func,
  ProgressComponent: PropTypes.elementType
};

export const TextInputBase = RawTextInputBase;
